
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const InfoCenterPage = lazy(() => import('../pages/info-center/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Service Pages
const FreeWarehousePage = lazy(() => import('../pages/services/free-warehouse/page'));
const TransitPage = lazy(() => import('../pages/services/transit/page'));
const ValueAddedPage = lazy(() => import('../pages/services/value-added/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/iletisim',
    element: <ContactPage />
  },
  {
    path: '/blog',
    element: <InfoCenterPage />
  },
  {
    path: '/hizmetler/serbest-depo',
    element: <FreeWarehousePage />
  },
  {
    path: '/hizmetler/transit',
    element: <TransitPage />
  },
  {
    path: '/hizmetler/katma-degerli',
    element: <ValueAddedPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
